import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppModulesType } from '../../../../../../_shared/enums/appModulesType.enum';
import { DocumentSource } from '../../../../../../_shared/enums/documentSource.enum';
import { ReservationType } from '../../../../../../_shared/enums/schedule/reservationType.enum';
import { Document } from '../../../../../../_shared/model';
import { HelperService } from '../../../../../../_shared/services';
import { ActiveModulesService } from '../../../../../../_shared/services/activeModules.service';
import { HelperNavigateService } from '../../../../../../_shared/services/helper-navigate.service';
import { PaperType } from './../../../../../../_shared/enums/PaperType.enum';
import { PortfolioPaper } from './../../../../../../_shared/model/portfolio/portfolioPaper.model';
import { PfType } from './../../_common/enum/pf-type.enum';

@Component({
    selector: 'app-portfolio-list-item',
    templateUrl: './portfolio-list-item.component.html',
    styleUrls: ['./portfolio-list-item.component.scss'],
})
export class PortfolioListItemComponent implements OnInit {
    constructor(
        private helper: HelperService,
        private helperNavigate: HelperNavigateService,
        private datePipe: DatePipe,
        private isAm: ActiveModulesService,
    ) {}

    @Input()
    public data: PortfolioPaper;

    @Input()
    public isReadOnly = false;

    @Input()
    public showCreationLocation = false;

    @Input()
    public type: PfType;
    //customer/term

    @Input()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public termData: any;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() public onPrint = new EventEmitter();

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() public onSend = new EventEmitter();

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() public onSendCrpp = new EventEmitter();

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() public onPreview = new EventEmitter();

    @Output() public mergeWithDocumentClick = new EventEmitter();

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() public onClick = new EventEmitter();

    @Output() public redirect = new EventEmitter();

    @Output() public stopShare = new EventEmitter();

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() public onStopCrppShare = new EventEmitter();

    @Output() public attachToHD = new EventEmitter();

    public reservationType: typeof ReservationType = ReservationType;
    public pfType = PfType;
    public paperType = PaperType;
    public isOccupationalMedicineActive: boolean;
    public isCRPPModuleActive: boolean;

    public ngOnInit() {
        if (this.type !== PfType.PUBLIC) {
            this.tooltipText = `Stranka ima dostop do dokumenta na povezavi. 
            ${
                this.data?.lastPublicAccess
                    ? `(Zadnji dostop stranke: ${this.datePipe.transform(<Date>this.data?.lastPublicAccess, 'dd.MM.yyyy HH:mm')})`
                    : '(Stranka še ni dostopala do dokumenta)'
            }`;
        }
        this.isOccupationalMedicineActive = this.isAm.isAM(AppModulesType.OCCUPATIONAL_MEDICINE);
        this.isCRPPModuleActive = this.isAm.isAM(AppModulesType.EZDRAVJE);
    }

    public print(): void {
        this.onPrint.emit(this.data);
    }
    public clickRow(): void {
        this.onClick.emit(this.data);
    }

    public send(): void {
        this.onSend.emit(this.data);
    }
    public redirectVisitOrReservation(): void {
        this.redirect.emit(this.data);
    }

    public preview(): void {
        this.onPreview.emit(this.data);
    }
    public stopSharing(): void {
        this.stopShare.emit(this.data);
    }
    public attachToHdChat(): void {
        this.attachToHD.emit(this.data);
    }
    public mergeWithDocument(): void {
        this.mergeWithDocumentClick.emit(this.data);
    }
    public sendCRPP(): void {
        this.onSendCrpp.emit(this.data);
    }

    public cancelCRPPShare(): void {
        this.onStopCrppShare.emit(this.data);
    }
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public tooltipText: string;

    // public getIconType(): string {
    //     return this.helper.getIconType(this.data.contentType);
    // }

    public openSource(data: Document): void {
        if (data.documentSource === DocumentSource.RESERVATION) {
            this.helperNavigate.navigateToReservaton(data.prereservationId);
        } else if (data.documentSource === DocumentSource.VISIT) {
            this.helperNavigate.navigateToVisitPrereservation(data.prereservationId);
        }
    }

    public get canSendToCrpp(): boolean {
        return (
            this.isCRPPModuleActive &&
            this.data?.signedPaper &&
            !this.data?.crppShared &&
            (this.data?.paperType === PaperType.MEDIFIT_MEDICAL_REPORT ||
                this.data?.paperType === PaperType.IZVID ||
                this.data?.paperType === PaperType.NAPREDNI_IZVID)
        );
    }

    public get canCancelCrppShare(): boolean {
        return (
            this.isCRPPModuleActive &&
            this.data?.signedPaper &&
            this.data?.crppShared &&
            (this.data?.paperType === PaperType.MEDIFIT_MEDICAL_REPORT ||
                this.data?.paperType === PaperType.IZVID ||
                this.data?.paperType === PaperType.NAPREDNI_IZVID)
        );
    }
}
